import clsx from "clsx";
import { Alert as MaterialAlert, AlertProps } from "@mui/material";
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

type Props = {
  severity?: "success" | "warning" | "error" | "info";
};

function Alert({
  children,
  className,
  severity,
  ...props
}: AlertProps & Props) {
  const realSeverity = severity === "error" ? "warning" : severity;
  const classes = useStyles();
  return (
    <MaterialAlert
      severity={realSeverity}
      {...props}
      className={clsx(className, classes.alert, `severity-${severity}`)}
    >
      {children}
    </MaterialAlert>
  );
}

const useStyles = createUseStyles(() => ({
  alert: {
    "&.MuiAlert-root": {
      padding: [0, 7],
    },
    color: `${theme.color.white} !important`,
    "& *": {
      color: `${theme.color.white} !important`,
    },
    background: theme.color.green,
    "&.severity-success": {
      background: theme.color.green,
    },
    "&.severity-error": {
      background: theme.color.red,
    },
    "&.severity-warning": {
      background: theme.color.orange,
    },
    "&.severity-info": {
      background: theme.color.blue,
    },
  },
}));

export default Alert;
